import type {
  RegisterInvalidParam,
  RegisterInvalidParams,
} from './InvalidParams';

type InvalidErrors = {
  qualificationCodeListError?: RegisterInvalidParam;
  graduationYearError?: RegisterInvalidParam;
  schoolNameError?: RegisterInvalidParam;
  schoolTypeIdError?: RegisterInvalidParam;
  birthdateError?: RegisterInvalidParam;
  prefectureIdError?: RegisterInvalidParam;
  nameError?: RegisterInvalidParam;
  emailError?: RegisterInvalidParam;
  phoneNumberError?: RegisterInvalidParam;
  passwordError?: RegisterInvalidParam;
};

export const createInvalidErrors = (
  invalidParams?: RegisterInvalidParams,
): InvalidErrors => ({
  qualificationCodeListError: invalidParams?.find(
    (value) => value.name === 'qualificationCodeList',
  ),
  graduationYearError: invalidParams?.find(
    (value) => value.name === 'graduationYear',
  ),
  schoolNameError: invalidParams?.find((value) => value.name === 'schoolName'),
  schoolTypeIdError: invalidParams?.find(
    (value) => value.name === 'schoolTypeId',
  ),
  birthdateError: invalidParams?.find((value) => value.name === 'birthdate'),
  prefectureIdError: invalidParams?.find(
    (value) => value.name === 'prefectureId',
  ),
  nameError: invalidParams?.find((value) => value.name === 'name'),
  emailError: invalidParams?.find((value) => value.name === 'email'),
  phoneNumberError: invalidParams?.find(
    (value) => value.name === 'phoneNumber',
  ),
  passwordError: invalidParams?.find((value) => value.name === 'password'),
});
